var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbSalebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13726_3678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3583 1H7.40028C5.8141 1 4.53063 2.25926 4.53063 3.81551V13.4144H2.65385C2.2906 13.4144 2 13.6995 2 14.0559V15.2914C2 16.7883 3.23504 18 4.76068 18H14.0356C15.5613 18 16.7963 16.7883 16.7963 15.2914V14.8756C16.7963 14.6855 16.7963 11.8106 16.7963 9.20894V3.81551C16.7963 2.96017 17.4865 2.28302 18.3704 2.28302C18.7215 2.28302 19.0121 1.98602 19.0121 1.62963C19 1.28512 18.7094 1.01188 18.3583 1ZM4.76068 16.717C3.94943 16.717 3.30769 16.0874 3.30769 15.2914V14.6855H11.287V15.2914C11.287 15.6478 11.3597 15.9923 11.505 16.3131L11.6866 16.717H4.76068ZM15.7429 2.69881C15.5976 3.01957 15.5128 3.3522 15.5007 3.69672V3.98183V9.20894C15.5007 11.7037 15.5007 14.6737 15.5007 14.8756V15.2914C15.5007 16.0992 14.859 16.717 14.0477 16.717L13.8298 16.7051C13.8056 16.6932 13.7813 16.6932 13.7692 16.6932C13.067 16.5507 12.5826 15.9804 12.5826 15.2914V14.0559C12.5826 13.6995 12.292 13.4144 11.9288 13.4144H5.83832V3.81551C5.83832 2.96017 6.52849 2.28302 7.40028 2.28302H15.9366L15.7429 2.69881Z",
    fill: "#4F5E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61837 6.15593H9.08347C9.38617 6.15593 9.64045 5.91833 9.64045 5.62134C9.64045 5.47878 9.59201 5.33622 9.48304 5.22931C9.37406 5.12239 9.24087 5.06299 9.07136 5.06299H7.58204C7.43674 5.06299 7.30355 5.13427 7.20669 5.24119C7.09771 5.3481 7.04928 5.49066 7.06139 5.63322C7.07349 5.91833 7.31566 6.15593 7.61837 6.15593Z",
    fill: "#4F5E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5849 9.61279H7.58204C7.43674 9.62467 7.30355 9.68407 7.20669 9.79099C7.09771 9.89791 7.04928 10.0405 7.06139 10.183C7.07349 10.48 7.31566 10.7057 7.61837 10.7057H10.597C10.8997 10.7057 11.1419 10.4681 11.154 10.1711C11.154 10.0286 11.1055 9.88603 10.9966 9.77911C10.8876 9.67219 10.7423 9.61279 10.5849 9.61279Z",
    fill: "#4F5E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0258 7.34375H7.56993C7.43674 7.35563 7.30355 7.41503 7.20669 7.52195C7.09771 7.62886 7.04928 7.77142 7.06139 7.91398C7.07349 8.21098 7.31566 8.43669 7.61837 8.43669H12.05C12.3527 8.43669 12.5949 8.1991 12.607 7.9021C12.607 7.75954 12.5585 7.61699 12.4496 7.51007C12.3285 7.40315 12.1953 7.34375 12.0258 7.34375Z",
    fill: "#4F5E71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13726_3678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(2 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbSalebookIcon);
export default __webpack_public_path__ + "static/media/ub-salebookIcon.283c4443eb87fba51276bce22cc2c727.svg";
export { ForwardRef as ReactComponent };